export const LIST_STORE = 'LIST_STORE';
export const LIST_PACKAGE = 'LIST_PACKAGE';
export const LIST_DEALS = 'LIST_DEALS';
export const LIST_PACKAGE_LADIBOOST = 'LIST_PACKAGE_LADIBOOST';
export const LIST_PACKAGE_COURSE = 'LIST_PACKAGE_COURSE';
export const UPGRADE_STORE = 'UPGRADE_STORE';
export const INFO_LADIBOOST = 'INFO_LADIBOOST';
export const ACTIVE_LADIBOOST = 'ACTIVE_LADIBOOST';
export const DOWNGRADE_STORE = 'DOWNGRADE_STORE';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const GET_USERINFO = 'GET_USERINFO';
export const ACTIVE_STORE = 'ACTIVE_STORE';
export const UPGRADE_STORE_LIST = 'UPGRADE_STORE_LIST';
export const CHANGE_PACKAGE_STORE = 'CHANGE_PACKAGE_STORE';
export const GET_ADDON_LIST = 'GET_ADDON_LIST';
export const GET_RESOURCE_LIMIT_CONFIG = 'GET_RESOURCE_LIMIT_CONFIG';
export const ADD_RESOURCE_LIMIT = 'ADD_RESOURCE_LIMIT';
export const UPDATE_RESOURCE_LIMIT = 'UPDATE_RESOURCE_LIMIT';
export const DELETE_RESOURCE_LIMIT = 'DELETE_RESOURCE_LIMIT';
export const BUY_RESOURCE = 'BUY_RESOURCE';

export const LIST_STAFFS = 'LIST_STAFFS';
export const RENEW_DEMO = 'RENEW_DEMO';
export const CREATE_TRIAL = 'CREATE_TRIAL';
export const CANCEL_TRIAL = 'CANCEL_TRIAL';